import { Component, input, OnDestroy, OnInit, output, DestroyRef, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, filter, tap } from 'rxjs/operators';
import { DefaultSelectionValue, EMPTY_STRING, FormGroupValue, InputProps } from '@miq/shared-models';
import { MatIcon } from '@angular/material/icon';
/*
 * L2-R6: moved from `src/app/shared/components/filters-bar/search-bar/search-bar.component.ts`
 * (2 reports references + 1 host). `InputProps` and `EMPTY_STRING` were already in
 * @miq/shared-models. The old host path is a re-export shim.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.scss',
  styles: [
    `
      .multiselect-clear {
        position: absolute;
        top: 10px;
        right: 34px;
        font-size: 19px;
        cursor: pointer;
      }
    `,
  ],
  imports: [FormsModule, ReactiveFormsModule, MatIcon],
})
export class SearchBarComponent<T = DefaultSelectionValue> implements OnInit, OnDestroy {
  protected destroyRef = inject(DestroyRef);
  props = input<InputProps<T>>();
  readonly searchValue = input<string>('');
  search = output<FormGroupValue<T> | string>();
  private prevText = EMPTY_STRING;
  control = new FormControl();
  ngOnInit() {
    this.control.setValue(this.searchValue());
    this.control.valueChanges
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        debounceTime(300),
        filter(
          // emit if trimmed text bigger than 3 OR if is empty after a valid prev search (reset)
          text => text != null && (text.trim().length >= 3 || (this.prevText !== EMPTY_STRING && text.length === 0))
        ),
        tap(text => (this.prevText = text))
      )
      .subscribe(value =>
        this.props() && this.props().field ? this.search.emit({ [this.props().field]: value }) : this.search.emit(value)
      );
  }
  clearFilter() {
    this.control.setValue(null);
    this.search.emit(this.props()?.field ? { [this.props().field]: null } : null);
  }
  ngOnDestroy() {
    /* REQUIRED by untilDestroyed */
  }
}
